const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20director%20explaining%20scene%20to%20actors%2C%20camera%20crew%20working%2C%20professional%20film%20production%2C%20warm%20cinematic%20lighting%2C%20candid%20moment%2C%20documentary%20style&width=800&height=500&seq=media-01&orientation=landscape',
    title: '《封神第二部》特效制作全流程揭秘',
    duration: '幕后花絮',
    views: '128万次播放',
    tag: '独家',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20interview%20in%20intimate%20setting%2C%20actor%20speaking%20passionately%2C%20warm%20studio%20lighting%2C%20professional%20video%20production%2C%20editorial%20photography%2C%20cinematic%20portrait%20style&width=800&height=500&seq=media-02&orientation=landscape',
    title: '周迅独家专访：从影30年的变与不变',
    duration: '明星专访',
    views: '96万次播放',
    tag: '独家',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20critics%20roundtable%20discussion%2C%20professional%20panel%2C%20warm%20theater%20setting%2C%20intellectual%20atmosphere%2C%20cinematic%20lighting%2C%20editorial%20photography&width=800&height=500&seq=media-03&orientation=landscape',
    title: '2026暑期档票房复盘：赢家与输家',
    duration: '专题讨论',
    views: '73万次播放',
    tag: '',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20award%20ceremony%20backstage%2C%20celebrities%20celebrating%2C%20golden%20trophy%2C%20champagne%2C%20emotional%20moment%2C%20warm%20atmosphere%2C%20documentary%20photography%20style&width=800&height=500&seq=media-04&orientation=landscape',
    title: '金鸡奖颁奖礼幕后：感动与泪水的瞬间',
    duration: '幕后花絮',
    views: '65万次播放',
    tag: '',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            幕后花絮
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            独家视频探班、明星专访与行业深度讨论
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl md:text-2xl text-white ml-0.5"></i>
                    </div>
                  </div>
                  {item.tag && (
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-[10px] font-semibold">
                        {item.tag}
                      </span>
                    </div>
                  )}
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 rounded bg-black/60 text-white text-[10px]">
                      {item.duration}
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-heading font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors mb-1">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400">{item.views}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}